import { ModalSheet, useModal } from '@boschebike/ebds-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModalSheetHidden } from '../../store/slices/modalSheet.slice';
import { ModalAnnex } from './ModalAnnex';

const customModals = {
  annex: {
    Component: ModalAnnex,
  },
};

export const EbdsModalSheet = () => {
  const dispatch = useDispatch();
  const { dispatchModal, modalSheetProps, isHidden } = useModal({
    customModals,
  });

  const currentModalConfig = useSelector(({ modalSheet }) => modalSheet);

  useEffect(() => {
    dispatchModal(currentModalConfig);
  }, [dispatchModal, currentModalConfig]);

  useEffect(() => {
    if (isHidden) {
      dispatch(setModalSheetHidden());
    }
  }, [dispatch, isHidden]);

  return <ModalSheet {...modalSheetProps} />;
};
